import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorCampaignList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M9.75 6.75a.75.75 0 0 1 0-1.5h10.5a.75.75 0 0 1 0 1.5H9.75Zm0 6a.75.75 0 0 1 0-1.5h10.5a.75.75 0 0 1 0 1.5H9.75ZM9 18c0 .414.336.75.75.75h10.5a.75.75 0 0 0 0-1.5H9.75A.75.75 0 0 0 9 18Z"
    />
    <path
      fill="#F7A600"
      d="M6.747 4.802c.022-.118-.068-.26-.18-.26l-1.282-.188-.584-1.226a.18.18 0 0 0-.09-.095c-.113-.07-.248-.023-.315.095l-.562 1.226-1.282.189c-.067 0-.112.023-.135.07a.236.236 0 0 0 0 .33l.922.944-.225 1.344c0 .047 0 .094.023.141.067.118.202.166.315.095l1.146-.637 1.147.637c.022.023.067.023.112.023h.045a.244.244 0 0 0 .18-.283l-.225-1.344.922-.943a.13.13 0 0 0 .068-.118ZM6 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-1.5 7.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
    />
  </svg>
);
export default SvgTwoColorCampaignList;
